import React from 'react';
import { getColorForTaskStatus, getStatusTitle } from './task-status.consts';
import { TaskStatus as TaskStatusEnum } from '@bringg/types';
import './task-status.scss';

export interface TaskStatusTranslations {
	notAssigned: string;
	assigned: string;
	onTheWay: string;
	checkedIn: string;
	done: string;
	late: string;
	accepted: string;
	cancelled: string;
	rejected: string;
	unacknowledged: string;
	pending: string;
}

interface Props {
	status?: TaskStatusEnum;
	translations: TaskStatusTranslations;
}

const TaskStatus = (props: Props) => {
	const { status, translations } = props;

	return (
		<div className="task-status">
			<div className={`task-status-icon task-status-${getColorForTaskStatus(status)}`} />

			<div>{getStatusTitle(translations, status)}</div>
		</div>
	);
};

export default TaskStatus;
